let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i1TuF")).then(() => parcelRequire('1jUpD'));